import { render, staticRenderFns } from "./ChatEmotion.vue?vue&type=template&id=182c5680&scoped=true"
import script from "./ChatEmotion.vue?vue&type=script&lang=js"
export * from "./ChatEmotion.vue?vue&type=script&lang=js"
import style0 from "./ChatEmotion.vue?vue&type=style&index=0&id=182c5680&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182c5680",
  null
  
)

export default component.exports